import * as React from "react";
import { Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import axios from "axios";

// import TaskboardIcon from "@material-ui/icons/Assignment";
import EstimationIcon from "mdi-material-ui/BullseyeArrow";
import OrderIcon from "@material-ui/icons/FiberManualRecordOutlined";
import WarehouseIcon from "mdi-material-ui/Warehouse";
import FabricIcon from "@material-ui/icons/Gradient";
import GroupingIcon from "@material-ui/icons/GroupWorkOutlined";
import CutPlanIcon from "mdi-material-ui/ContentCut";
import RollPlanIcon from "mdi-material-ui/Layers";
import FeedbackIcon from "@material-ui/icons/Feedback";
import ReportIcon from "mdi-material-ui/FileChart";
import UserIcon from "mdi-material-ui/AccountGroup";
import LibraryIcon from "@material-ui/icons/LibraryBooks";
import SettingsIcon from "@material-ui/icons/Settings";
import DownloadsIcon from "@material-ui/icons/GetApp";
import HelpIcon from "mdi-material-ui/Lifebuoy";
import ManualIcon from "mdi-material-ui/FileDocument";
import LicenseIcon from "mdi-material-ui/License";
import ScheduledIcon from "@material-ui/icons/Schedule";
import IntegrationIcon from "mdi-material-ui/CogTransfer";
import HistoryIcon from "@material-ui/icons/History";
import OrderStatusIcon from "./pages/order-status/OrderStatusIcon";

import MenuIcon from "@material-ui/icons/Menu";
// import logo from "./asset/img/logo.png";
import logo from "./asset/img/wfx-logo.png";
import avatar from "./asset/img/faces/avatar-male.png";

import { App as JApp, Resource, createAuthProvider, createDataProvider, WithPermissions, resolveBrowserLocale } from "jazasoft";
import layReducer from "./pages/feedback/layslip/layReducer";
// import cutPlanReducer from "./pages/cutplan/archive/cutPlanReducer";
import scheduledTaskReducer from "./reducers/scheduledTaskReducer";

import theme from "./theme";
import hasPrivilege from "./utils/hasPrivilege";

import Notification from "./components/notification/Notification";
import Dashboard from "./pages/dashboard/Dashboard";
import Report from "./pages/reports/Report";
import Profile from "./pages/profile/Profile";
// import Taskboard from "./pages/taskboard/Taskboard";
import Order from "./pages/OrderHome";
import Login from "./pages/Login";

//Estimation Module
import {
  CuChecklistHome,
  CuChecklistCreate,
  CuChecklistView
  // CuChecklistItemEdit
} from "./pages/estimation/cu-checklist";
import {
  CostingHome,
  CostingView
  // CostingHistory
} from "./pages/estimation/costing";
import {
  EstimationHome,
  EstimationView
  //  EstimationHistory
} from "./pages/estimation/estimation";

import { OrderHome, OrderCreate, OrderEdit, OrderView, OrderUpload, OrderHistory } from "./pages/order-mngmt/order";
import { FactoryProductionOrder, FactoryProductionOrderView } from "./pages/order-mngmt/fpo";

//WareHouse Pages
import { Invoice, InvoiceCreate, InvoiceEdit, InvoiceView, InvoiceUpload, InvoiceHistory } from "./pages/warehouse/association-grn";
import { MaterialTransfer, MaterialTransferPOView, MaterialTrasnferInvoiceView, MaterialTransferItemView } from "./pages/warehouse/material-transfer";
import FabricQuality from "./pages/warehouse/quality-control/home/FabricQuality";
import FabricQualityPOView from "./pages/warehouse/quality-control/po-view/FabricQualityPOView";
import FabricQualityInvoiceView from "./pages/warehouse/quality-control/invoice-view/FabricQualityInvoiceView";
import { FabricRelease, FabricReleaseView } from "./pages/warehouse/fabric-release";
import { FabricHome, FabricCreate, FabricEdit, FabricView, FabricUpload } from "./pages/warehouse/item-master";

import { GroupingView } from "./pages/grouping";
import { CutPlanHome, CutOrder, PreRunCutOrder, CutPlanView } from "./pages/cutplan";
import { RollPlanView } from "./pages/rollplan";
//Feedback Pages
import { LaySlipView, LayEdit } from "./pages/feedback/layslip";
import { BundlingView } from "./pages/feedback/bundling";
import { PartRecuttingView } from "./pages/feedback/part-recutting";
import {
  // GarmentRecuttingView,
  LayFeedback
} from "./pages/feedback/garment-recutting";
import { OrderClosureView } from "./pages/feedback/order-closure";
import { GarmentRejectionView } from "./pages/feedback/garment-rejection";

//Integration
import { ExternalApp, ExtrenalAppCreate, ExternalAppView } from "./pages/integration/external-apps";
import { ApiKey, ApiKeyCreate, ApiKeyView } from "./pages/integration/api-key";

//Reporting Pages
import {
  MacroReport,
  AggregateReconciliationReport,
  WastageReport,
  EndBitsReport,
  MarkerEfficiencyReport,
  CutAnalysisReport,
  RollVariationReport,
  MonitorReport,
  OrderStatusReport,
  AggregateCuttingReport,
  CommonReport
} from "./pages/reports/mcro";
import {
  MicroReport,
  MicroHome,
  ReconciliationReport,
  CutPlanReport,
  RollPlanReport,
  FabricReleaseReport,
  LayslipFeedbackReport,
  PartsRecuttingReport,
  GarmentRecuttingReport,
  BundleReport,
  DailyCuttingReport,
  ClosurePendingReport,
  RollUtilizationReport
} from "./pages/reports/micro";
import { UserHome, UserCreate, UserEdit, UserView, UserUpload } from "./pages/user";
import Apk from "./pages/downloads/Apk";
// Library Pages
// import { AlertParameterHome, CreateAlertReason, EditAlertReason } from "./pages/library/AlertReason";
import { AlertParameter, AlertParameterCreate, AlertParameterEdit, AlertParameterView } from "./pages/library/alert-parameter";
import { Customer, CustomerCreate, CustomerEdit } from "./pages/library/customer";
import { SeasonHome, CreateSeason, EditSeason } from "./pages/library/Season";
import { SupplierHome, CreateSupplier, EditSupplier } from "./pages/library/Supplier";
import { SizeChart, SizeChartCreate, SizeChartEdit, SizeChartView } from "./pages/library/size-chart";
import { FabricPatternHome, CreateFabricPattern, EditFabricPattern } from "./pages/library/FabricPattern";
import { FabricCategoryHome, CreateFabricCategory, EditFabricCategory } from "./pages/library/FabricCategory";
import { Product, ProductCreate, ProductEdit, ProductView } from "./pages/library/product";
import { CreateTable, EditTable, TableHome } from "./pages/library/Table";
import { CreateUnit, EditUnit, UnitHome } from "./pages/library/Unit";
// import { UnitHome } from "./pages/library/Unit";
import { WarehouseCreate, WarehouseEdit, Warehouse } from "./pages/library/warehouse";
import { CreateDepartment, EditDepartment, DepartmentHome } from "./pages/library/Department";

//Settings Page
import { SettingHome, SettingView } from "./pages/setting";
import Downloads from "./pages/downloads/Downloads";
import { Docs, Section, Topic, CreateTopic, EditTopic } from "./pages/docs";
import License from "./pages/license/License";
// Developers Page
import Reset from "./pages/dev/Reset";
import Monitoring from "./pages/dev/Monitoring";
import ExecuteLogs from "./pages/dev/ExecuteLogs";
import MergeRolls from "./pages/dev/MergeRolls";
import ScheduledTask from "./pages/scheduledTask/ScheduledTask";

import { Role } from "./utils/types";
import { MicroReportId, MacroReportId } from "./constants";
import i18nProvider from "./i18nProvider";
import { SystemActivityHome } from "./pages/system-activity";
import LibraryHistory from "./pages/library/History";
import { isEmpty, listFromCsv } from "./utils/helpers";
import { ResourceId, Scope } from "./utils/privilege";
import OrderManagement from "./pages/order-mngmt/OrderManagement";
import OrderStatusHome from "./pages/order-status/OrderStatusHome";
import OpenOrderReconciliationReport from "./pages/reports/mcro/OpenOrderReconciliationReport";

export const appId = "optacut";

const estimationTenantIds = ["test", "laguna_v5", "aquarelle", "aqtest", "rdk186", "wfx", "ranger_v5", "vd_v5", "marketing"];

let splits = window.location.href?.includes("login") ? window.location.href?.split("//")[1].split("/") : [];
let tenantId = splits?.length === 3 ? splits[1] : null;
if (!tenantId) {
  try {
    const authStateStr = localStorage.getItem(`authState_${appId}`);
    const authState = JSON.parse(authStateStr);
    tenantId = authState?.clientId;
  } catch (error) {
    console.log(error);
  }
}

export const rootUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
// export const rootUrl = `http://${window.location.hostname}:8005`;
// export const rootUrl = `https://optacut.jazasoft.com`;

export const appUrl = `${rootUrl}/api`;
export const authUrl = "https://iam-next.jazasoft.com";
export const authServerUrl = `https://iam-next.jazasoft.com/api`;

/// Env: Production ///////
const authProvider = createAuthProvider(() => authUrl, "Basic Y2xpZW50OnNlY3JldA==", appId);
export const dataProvider = createDataProvider(`${rootUrl}/api`, appId);

(function () {
  axios
    .get(`${rootUrl}/buildInfo`)
    .then(response => {
      localStorage.setItem(`${appId}-build-info`, JSON.stringify(response.data));
    })
    .catch(err => {
      console.log(err);
    });
})();

const history = createBrowserHistory();
const customReducers = {
  lay: layReducer,
  // cutPlan: cutPlanReducer,
  scheduledTask: scheduledTaskReducer
};

const homeMicroReports = [
  { name: "reconciliation", component: <ReconciliationReport resource="orders" /> },
  { name: "cutplan", component: <CutPlanReport resource="orders" /> },
  { name: "rollplan", component: <RollPlanReport resource="orders" /> },
  { name: "fabricRelease", component: <FabricReleaseReport resource="orders" /> },
  { name: "layslipFeedback", component: <LayslipFeedbackReport resource="orders" /> },
  { name: "partsRecutting", component: <PartsRecuttingReport resource="orders" /> },
  { name: "garmentRecutting", component: <GarmentRecuttingReport resource="orders" /> },
  { name: "bundle", component: <BundleReport resource="orders" /> },
  { name: "rollUtilization", component: <RollUtilizationReport resource="orders" /> }
];

const macroReports = [
  { name: "reconciliation", component: <AggregateReconciliationReport resource="orders" /> },
  { name: "openOrderReconciliation", component: <OpenOrderReconciliationReport resource="orders" /> },
  { name: "wastage", component: <WastageReport resource="orders" /> },
  { name: "endBits", component: <EndBitsReport resource="orders" /> },
  { name: "markerEfficiency", component: <MarkerEfficiencyReport resource="orders" /> },
  { name: "cutAnalysis", component: <CutAnalysisReport resource="orders" /> },
  { name: "rollVariation", component: <RollVariationReport resource="orders" /> },
  { name: "monitor", component: <MonitorReport resource="orders" /> },
  { name: "orderStatus", component: <OrderStatusReport resource="orders" /> },
  { name: "cuttingReport", component: <AggregateCuttingReport resource="AggregateCuttingReport" /> },
  { name: "commonReport", component: <CommonReport resource="CommonReport" /> }
];

const customRoutes = [
  <Route name="users" exact path="/users/upload" component={UserUpload} />,
  <Route name="apk" exact path="/Apk" component={Apk} />,
  <Route name="reports" exact path="/reports" component={Report} />,
  <Route name="executeLogs" exact path="/executeLogs" component={ExecuteLogs} />,
  <Route name="mergeRolls" exact path="/mergeRolls" component={MergeRolls} />,
  <Route name="profile" exact path="/profile" component={Profile} />,
  <Route name="layslip" exact path="/feedback/layslip/:orderId/view/lay" component={LayEdit} />,
  <Route name="layslip" exact path="/feedback/garmentRecutting/:orderId/view/lay" component={LayFeedback} />,
  <Route name="orders" exact path="/orders/:id/history" component={OrderHistory} />,
  <Route name="invoices" exact path="/warehouse/invoices/:id/history" component={InvoiceHistory} />,
  <Route
    name="material-transfer"
    exact
    path="/warehouse/material-transfer/:id/po-view"
    render={routeProps => <WithPermissions render={props => <MaterialTransferPOView {...props} />} {...routeProps} />}
  />,
  <Route
    name="material-transfer"
    exact
    path="/warehouse/material-transfer/:id/invoice-view"
    render={routeProps => <WithPermissions render={props => <MaterialTrasnferInvoiceView {...props} />} {...routeProps} />}
  />,
  <Route
    name="material-transfer"
    exact
    path="/warehouse/material-transfer/:id/item-view"
    render={routeProps => <WithPermissions render={props => <MaterialTransferItemView {...props} />} {...routeProps} />}
  />,
  <Route
    name="quality"
    exact
    path="/warehouse/quality/:id/po-view"
    render={routeProps => <WithPermissions render={props => <FabricQualityPOView {...props} />} {...routeProps} />}
  />,
  <Route
    name="quality"
    exact
    path="/warehouse/quality/:id/invoice-view"
    render={routeProps => <WithPermissions render={props => <FabricQualityInvoiceView {...props} />} {...routeProps} />}
  />,
  <Route
    name="cutPlan"
    exact
    path="/cutPlan/bulk/:id"
    render={routeProps => <WithPermissions render={props => <CutOrder {...props} />} {...routeProps} />}
  />,
  <Route
    name="cutPlan"
    exact
    path="/cutPlan/prerun/:id"
    render={routeProps => <WithPermissions render={props => <PreRunCutOrder {...props} />} {...routeProps} />}
  />,
  <Route
    name="cutPlan"
    exact
    path="/cutPlan/:lotType/:orderId/:cutOrderId"
    render={routeProps => <WithPermissions render={props => <CutPlanView {...props} />} {...routeProps} />}
  />,
  <Route
    name="cutPlan"
    exact
    path="/cutPlan/prerun/:orderId/:cutOrderId"
    render={routeProps => <WithPermissions render={props => <CutPlanView {...props} />} {...routeProps} />}
  />,
  <Route
    name="invoices"
    exact
    path="/warehouse/invoices/upload"
    render={routeProps => <WithPermissions render={props => <InvoiceUpload {...props} basePath="/warehouse/invoices" />} {...routeProps} />}
  />,
  <Route
    name="orders"
    exact
    path="/orders/upload"
    render={routeProps => <WithPermissions render={props => <OrderUpload {...props} basePath="/orders" />} {...routeProps} />}
  />,
  <Route
    name="orders"
    exact
    path="/order-mngmt/orders/upload"
    render={routeProps => <WithPermissions render={props => <OrderUpload {...props} basePath="/order-mngmt/orders" />} {...routeProps} />}
  />,
  <Route
    name="orders"
    exact
    path="/order-mngmt"
    render={routeProps => <WithPermissions render={props => <OrderManagement {...props} basePath="/order-mngmt" />} {...routeProps} />}
  />,
  <Route
    name="fabrics"
    exact
    path="/warehouse/fabrics/upload"
    render={routeProps => <WithPermissions render={props => <FabricUpload {...props} />} {...routeProps} />}
  />,
  <Route
    name="history"
    exact
    path="/library/:i18nKey/:id/history"
    render={routeProps => <WithPermissions render={props => <LibraryHistory {...props} />} {...routeProps} />}
  />,
  // <Route name="costings" exact path="/estimation/costings/:id/history" component={CostingHistory} />,
  // <Route name="estimations" exact path="/estimation/estimations/:id/history" component={EstimationHistory} />,
  // <Route name="cuChecklists" exact path="/estimation/cuChecklists/:id/edit/:itemId" component={CuChecklistItemEdit} />,
  <Route
    name="monitor"
    exact
    path="/monitor"
    render={routeProps => <Order name="orders" resource="orders" i18nKey="orders" basePath="monitor" {...routeProps} />}
  />,
  <Route name="monitor" exact path="/monitor/:id/view" component={Monitoring} />,
  <Route
    name="reset"
    exact
    path="/reset"
    render={routeProps => <Order name="orders" resource="orders" i18nKey="orders" basePath="reset" {...routeProps} />}
  />,
  <Route name="reset" exact path="/reset/:id/view" component={Reset} />,
  <Route
    name="DailyCuttingReport"
    exact
    path="/reports/micro/cuttingReport"
    render={routeProps => <WithPermissions render={props => <DailyCuttingReport {...props} />} {...routeProps} />}
  />,
  <Route
    name="closurePendingReport"
    exact
    path="/reports/micro/closurePendingReport"
    render={routeProps => <WithPermissions render={props => <ClosurePendingReport {...props} />} {...routeProps} />}
  />,
  ...homeMicroReports.map(({ name }) => (
    <Route
      key={`${name}-home`}
      name="reports"
      exact
      path={`/reports/micro/${name}`}
      render={routeProps => (
        <WithPermissions
          render={props => (
            <MicroHome
              report={name}
              filterDefaultValues={name === "reconciliation" ? { stateValue: "*Closed*" } : { stateValue: undefined }}
              {...props}
            />
          )}
          {...routeProps}
        />
      )}
    />
  )),
  ...homeMicroReports.map(({ name, component }) => (
    <Route
      key={`${name}-view`}
      name={name}
      exact
      path={`/reports/micro/${name}/:id/view`}
      render={routeProps => <WithPermissions render={props => React.cloneElement(component, props)} {...routeProps} />}
    />
  )),
  ...macroReports.map(({ name, component }) => (
    <Route
      name={name}
      exact
      path={`/reports/macro/${name}`}
      render={routeProps => <WithPermissions render={props => React.cloneElement(component, props)} {...routeProps} />}
    />
  )),
  ...["help", "manual"].flatMap(type => [
    <Route
      name={type}
      exact
      path={`/${type}/:sectionId`}
      render={routeProps => <WithPermissions render={props => React.createElement(Section, { ...props, type })} {...routeProps} />}
    />,
    <Route
      name={type}
      exact
      path={`/${type}/topics/create`}
      render={routeProps => <WithPermissions render={props => React.createElement(CreateTopic, { ...props, type })} {...routeProps} />}
    />,
    <Route
      name={type}
      exact
      path={`/${type}/topics/:id/edit`}
      render={routeProps => <WithPermissions render={props => React.createElement(EditTopic, { ...props, type })} {...routeProps} />}
    />,
    <Route
      name={type}
      exact
      path={`/${type}/topics/:id/view`}
      render={routeProps => <WithPermissions render={props => React.createElement(Topic, { ...props, type })} {...routeProps} />}
    />
  ])
];

const initialState = {
  jazasoft: {
    ui: {
      sidebarOpen: false,
      filterOpen: false,
      optimistic: false,
      viewVersion: 0
    }
  }
};
const resources = [
  { i18nKey: "orders", resource: "orders" },
  { i18nKey: "flowInfo", resource: "flow-info" },
  { i18nKey: "orderFlow", resource: "orderFlow" },
  { i18nKey: "invoices", resource: "invoices" },
  { i18nKey: "fabricItems", resource: "fabric-items" },
  { i18nKey: "fabricColors", resource: "fabric-colors" },
  { i18nKey: "rolls", resource: "rolls" },
  { i18nKey: "ledgers", resource: "ledgers" },
  { i18nKey: "fabrics", resource: "fabrics" },
  { i18nKey: "grouping", resource: "orders" },
  { i18nKey: "cutPlan", resource: "orders" },
  { i18nKey: "rollPlan", resource: "orders" },
  //Feedback Resources
  { i18nKey: "laylsip", resource: "orders" },
  { i18nKey: "partRecutting", resource: "orders" },
  { i18nKey: "garmentRecutting", resource: "orders" },
  { i18nKey: "garmentRejection", resource: "orders" },
  { i18nKey: "orderCompletion", resource: "orders" },
  //Library Resources
  { i18nKey: "alertParameters", resource: "alert-parameters" },
  { i18nKey: "customers", resource: "customers" },
  { i18nKey: "seasons", resource: "seasons" },
  { i18nKey: "suppliers", resource: "suppliers" },
  { i18nKey: "sizes", resource: "sizes" },
  { i18nKey: "fabric-patterns", resource: "fabric-patterns" },
  { i18nKey: "fabric-categories", resource: "fabric-categories" },
  { i18nKey: "products", resource: "products" },
  { i18nKey: "downloads", resource: "downloads" },
  { i18nKey: "tables", resource: "tables" },
  { i18nKey: "units", resource: "units" },
  { i18nKey: "departments", resource: "departments" },
  { i18nKey: "warehouses", resource: "warehouses" },
  { i18nKey: "system-activities", resource: "system-activities" }
];

const App = props => {
  let locale = resolveBrowserLocale();
  const serializedState = localStorage.getItem(`authState_${appId}`);

  let tenantId = localStorage.getItem(`${appId}-tenantId`);
  let unitIds = [];
  if (serializedState) {
    const authState = JSON.parse(serializedState);
    tenantId = authState?.tenant?.tenantId || tenantId;
    unitIds = isEmpty(authState?.units) ? authState?.tenant?.unitList?.map(e => e.unitId) || [] : listFromCsv(authState?.units);
    locale = authState?.locale || locale;
  }

  return (
    <JApp
      appId={appId}
      appName="OptaCut"
      appNameShort="OptaCut"
      authProvider={authProvider}
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      locale={locale}
      logo={logo}
      avatar={avatar}
      loginPage={Login}
      dashboard={props => (props && hasPrivilege(props.roles, props.hasAccess, "dashboard", "read") ? React.createElement(Dashboard, props) : null)}
      notification={props =>
        props && hasPrivilege(props.roles, props.hasAccess, "notification", "read") ? React.createElement(Notification, props) : null
      }
      history={history}
      theme={theme}
      initialState={initialState}
      customReducers={customReducers}
      customRoutes={customRoutes}
      resources={resources}>
      {({ roles, hasAccess, hasPermission, getPermissions }) => {
        let resourceList = [];

        const hasMicroAccess =
          Object.keys(MicroReportId)
            .map(key => hasPrivilege(roles, hasAccess, ResourceId.MICRO, Scope.READ))
            .filter(e => e).length > 0;
        const hasMacroAccess =
          Object.keys(MacroReportId)
            .map(key => hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ))
            .filter(e => e).length > 0;
        if (hasMicroAccess || hasMicroAccess) {
          resourceList.push(
            <Resource name="reports" icon={ReportIcon}>
              {hasMacroAccess && <Resource name="macro" resource="reports" home={MacroReport} icon={MenuIcon} />}
              {hasMicroAccess && <Resource name="micro" resource="reports" home={MicroReport} icon={MenuIcon} />}
            </Resource>
          );
        }

        // if (hasPrivilege(roles, hasAccess, "taskboard", "read")) {
        //   resourceList.push(<Resource name="taskboard" home={Taskboard} icon={TaskboardIcon} />);
        // }
        // if (hasPrivilege(roles, hasAccess, "order-status", "read")) {
        resourceList.push(<Resource name="order-status" resource="order-status" home={OrderStatusHome} icon={OrderStatusIcon} />);
        // }
        if (estimationTenantIds.includes(tenantId) && hasPrivilege(roles, hasAccess, "estimation", "read")) {
          resourceList.push(
            <Resource name="estimation" icon={EstimationIcon}>
              {hasPrivilege(roles, hasAccess, "cu_checklist", "read") && (
                <Resource
                  name="cuChecklists"
                  resource="cuChecklists"
                  home={CuChecklistHome}
                  create={CuChecklistCreate}
                  view={CuChecklistView}
                  icon={MenuIcon}
                />
              )}
              {hasPrivilege(roles, hasAccess, "costing", "read") && (
                <Resource name="costings" resource="costings" home={CostingHome} view={CostingView} icon={MenuIcon} />
              )}
              {hasPrivilege(roles, hasAccess, "estimation", "read") && (
                <Resource name="estimations" resource="estimations" home={EstimationHome} view={EstimationView} icon={MenuIcon} />
              )}
            </Resource>
          );
        }
        if (unitIds?.length <= 1) {
          if (hasPrivilege(roles, hasAccess, ResourceId.ORDER, Scope.READ)) {
            resourceList.push(
              <Resource name="orders" resource="orders" home={OrderHome} create={OrderCreate} edit={OrderEdit} view={OrderView} icon={OrderIcon} />
            );
          }
        } else {
          if (hasPrivilege(roles, hasAccess, ResourceId.ORDER, Scope.READ)) {
            resourceList.push(
              <Resource name="order-mngmt" icon={OrderIcon}>
                <Resource name="orders" resource="orders" home={OrderHome} create={OrderCreate} edit={OrderEdit} view={OrderView} icon={MenuIcon} />
                <Resource name="fpo" resource="fpo" home={FactoryProductionOrder} view={FactoryProductionOrderView} icon={MenuIcon} />
              </Resource>
            );
          }
        }

        const hasWarehousePrivilege =
          hasPrivilege(roles, hasAccess, ResourceId.INVOICE, Scope.READ) ||
          hasPrivilege(roles, hasAccess, ResourceId.GRN, Scope.READ) ||
          hasPrivilege(roles, hasAccess, ResourceId.ROLL, Scope.READ) ||
          hasPrivilege(roles, hasAccess, ResourceId.FABRIC_RELEASE, Scope.READ) ||
          hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.READ);
        if (hasWarehousePrivilege) {
          resourceList.push(
            <Resource name="warehouse" icon={WarehouseIcon}>
              {(hasPrivilege(roles, hasAccess, ResourceId.INVOICE, Scope.READ) || hasPrivilege(roles, hasAccess, ResourceId.GRN, Scope.READ)) && (
                <Resource
                  name="invoices"
                  resource="invoices"
                  home={Invoice}
                  create={InvoiceCreate}
                  edit={InvoiceEdit}
                  view={InvoiceView}
                  icon={MenuIcon}
                />
              )}
              {hasPrivilege(roles, hasAccess, ResourceId.ROLL, Scope.READ) && <Resource name="quality" home={FabricQuality} icon={MenuIcon} />}
              {hasPrivilege(roles, hasAccess, ResourceId.FABRIC_RELEASE, Scope.READ) && (
                <Resource name="fab-release" resource="order-flow" home={FabricRelease} view={FabricReleaseView} icon={MenuIcon} />
              )}
              {hasPrivilege(roles, hasAccess, ResourceId.MATERIAL_TRANSFER, Scope.READ) && (
                <Resource name="material-transfer" home={MaterialTransfer} icon={MenuIcon} />
              )}
              {hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.READ) && (
                <Resource
                  name="fabrics"
                  resource="fabrics"
                  home={FabricHome}
                  view={FabricView}
                  create={FabricCreate}
                  edit={FabricEdit}
                  icon={FabricIcon}
                />
              )}
            </Resource>
          );
        }
        if (hasPrivilege(roles, hasAccess, ResourceId.GROUPING, Scope.READ)) {
          resourceList.push(<Resource name="grouping" resource="orders" home={Order} view={GroupingView} icon={GroupingIcon} />);
        }
        if (hasPrivilege(roles, hasAccess, ResourceId.CUTPLAN, Scope.READ)) {
          resourceList.push(
            <Resource name="cutPlan" icon={CutPlanIcon}>
              <Resource name="bulk" resource="orders" home={CutPlanHome} icon={MenuIcon} />
              <Resource name="prerun" resource="orders" home={CutPlanHome} icon={MenuIcon} />
            </Resource>
          );
        }
        if (hasPrivilege(roles, hasAccess, ResourceId.LAY, Scope.READ)) {
          resourceList.push(<Resource name="rollPlan" resource="orders" home={Order} view={RollPlanView} icon={RollPlanIcon} />);
        }
        // const hasFeedbackAccess = ["layslip", "part_recutting", "garment_recutting", "garment_rejection", "close_order", "confirm_order"].some(
        //   action => hasPrivilege(roles, hasAccess, "feedback", "read", action)
        // );
        const hasFeedbackAccess = hasPrivilege(roles, hasAccess, ResourceId.FEEDBACK, Scope.READ);
        if (hasFeedbackAccess) {
          resourceList.push(
            <Resource name="feedback" icon={FeedbackIcon}>
              <Resource name="layslip" resource="orders" home={Order} view={LaySlipView} icon={MenuIcon} />
              {hasPrivilege(roles, hasAccess, ResourceId.NUMBERING_BUNDLING, Scope.READ) && (
                <Resource name="bundling" resource="orders" home={Order} view={BundlingView} icon={MenuIcon} />
              )}
              <Resource name="partRecutting" resource="orders" home={Order} view={PartRecuttingView} icon={MenuIcon} />
              <Resource name="garmentRejection" resource="orders" home={Order} view={GarmentRejectionView} icon={MenuIcon} />
              <Resource name="orderClosure" resource="orders" home={Order} view={OrderClosureView} icon={MenuIcon} />
              {/* {(hasPrivilege(roles, hasAccess, "feedback", "read", "layslip") || hasPrivilege(roles, hasAccess, "feedback", "write", "layslip")) && (
               
              {hasPrivilege(roles, hasAccess, ResourceId.FEEDBACK, Scope.READ) && (
                <Resource name="layslip" resource="orders" home={Order} view={LaySlipView} icon={MenuIcon} />
              )}
              {/* {(hasPrivilege(roles, hasAccess, "feedback", "read", "part_recutting") ||
                hasPrivilege(roles, hasAccess, "feedback", "write", "part_recutting")) && ( 
              {hasPrivilege(roles, hasAccess, ResourceId.FEEDBACK, Scope.READ) && (
                <Resource name="partRecutting" resource="orders" home={Order} view={PartRecuttingView} icon={MenuIcon} />
              )}
              {/* {(hasPrivilege(roles, hasAccess, "feedback", "read", "garment_recutting") ||
                  hasPrivilege(roles, hasAccess, "feedback", "write", "garment_recutting")) && (
                  <Resource name="garmentRecutting" resource="orders" home={Order} view={GarmentRecuttingView} icon={MenuIcon} />
                )} */}
              {/* {(hasPrivilege(roles, hasAccess, "feedback", "read", "garment_rejection") ||
                hasPrivilege(roles, hasAccess, "feedback", "write", "garment_rejection")) && ( 
              {hasPrivilege(roles, hasAccess, ResourceId.FEEDBACK, Scope.READ) && (
                <Resource name="garmentRejection" resource="orders" home={Order} view={GarmentRejectionView} icon={MenuIcon} />
              )}
              {/* {(hasPrivilege(roles, hasAccess, "feedback", "read", "close_order") ||
                  hasPrivilege(roles, hasAccess, "feedback", "write", "close_order") ||
                  hasPrivilege(roles, hasAccess, "feedback", "read", "confirm_order") ||
                  hasPrivilege(roles, hasAccess, "feedback", "write", "confirm_order")) && (
                  <Resource name="orderClosure" resource="orders" home={Order} view={OrderClosureView} icon={MenuIcon} />
                )} */}
            </Resource>
          );
        }

        if (hasPrivilege(roles, hasAccess, ResourceId.USER, Scope.READ)) {
          resourceList.push(
            <Resource name="users" resource="users" home={UserHome} create={UserCreate} edit={UserEdit} view={UserView} icon={UserIcon} />
          );
        }

        if (hasPrivilege(roles, hasAccess, ResourceId.LIBRARY, Scope.READ)) {
          resourceList.push(
            <Resource name="library" icon={LibraryIcon}>
              <Resource
                name="alertParameters"
                resource="alert-parameters"
                home={AlertParameter}
                create={AlertParameterCreate}
                edit={AlertParameterEdit}
                view={AlertParameterView}
                icon={MenuIcon}
              />
              <Resource name="customers" resource="customers" home={Customer} create={CustomerCreate} edit={CustomerEdit} icon={MenuIcon} />
              <Resource
                name="departments"
                resource="departments"
                home={DepartmentHome}
                create={CreateDepartment}
                edit={EditDepartment}
                icon={MenuIcon}
              />
              <Resource
                name="fabric-categories"
                resource="fabric-categories"
                home={FabricCategoryHome}
                create={CreateFabricCategory}
                edit={EditFabricCategory}
                icon={MenuIcon}
              />
              <Resource
                name="fabric-patterns"
                resource="fabric-patterns"
                home={FabricPatternHome}
                create={CreateFabricPattern}
                edit={EditFabricPattern}
                icon={MenuIcon}
              />
              <Resource
                name="products"
                resource="products"
                home={Product}
                create={ProductCreate}
                edit={ProductEdit}
                view={ProductView}
                icon={MenuIcon}
              />
              <Resource name="suppliers" resource="suppliers" home={SupplierHome} create={CreateSupplier} edit={EditSupplier} icon={MenuIcon} />
              <Resource name="seasons" resource="seasons" home={SeasonHome} create={CreateSeason} edit={EditSeason} icon={MenuIcon} />
              <Resource
                name="size-chart"
                resource="size-chart"
                home={SizeChart}
                create={SizeChartCreate}
                edit={SizeChartEdit}
                view={SizeChartView}
                icon={MenuIcon}
              />
              <Resource name="tables" resource="tables" home={TableHome} create={CreateTable} edit={EditTable} icon={MenuIcon} />
              <Resource name="units" resource="units" home={UnitHome} create={CreateUnit} edit={EditUnit} icon={MenuIcon} />
              {/* <Resource name="units" resource="units" home={UnitHome} icon={MenuIcon} /> */}
              <Resource name="warehouses" resource="warehouses" home={Warehouse} create={WarehouseCreate} edit={WarehouseEdit} icon={MenuIcon} />
            </Resource>
          );
        }

        if (hasPrivilege(roles, hasAccess)) {
          resourceList.push(<Resource name="system-activities" resource="system-activities" home={SystemActivityHome} icon={HistoryIcon} />);
        }

        if (roles?.includes(Role.MASTER)) {
          resourceList.push(
            <Resource name="integration" icon={IntegrationIcon}>
              <Resource
                name="externalApps"
                resource="externalApps"
                home={ExternalApp}
                create={ExtrenalAppCreate}
                view={ExternalAppView}
                icon={SettingsIcon}
              />
              <Resource name="apiKeys" resource="apiKeys" home={ApiKey} create={ApiKeyCreate} view={ApiKeyView} icon={SettingsIcon} />
            </Resource>
          );
        }

        if (hasPrivilege(roles, hasAccess, ResourceId.SETTING, Scope.READ)) {
          resourceList.push(<Resource name="settings" home={SettingHome} view={SettingView} icon={SettingsIcon} />);
        }
        if (roles && roles.includes(Role.MASTER)) {
          resourceList.push(<Resource name="scheduledTask" home={ScheduledTask} icon={ScheduledIcon} />);
        }
        resourceList.push(<Resource name="help" home={Docs} icon={HelpIcon} />);
        resourceList.push(<Resource name="downloads" home={Downloads} icon={DownloadsIcon} />);
        if (roles && roles.includes(Role.MASTER)) {
          resourceList.push(<Resource name="manual" home={Docs} icon={ManualIcon} />);
        }

        if (roles && (roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) || roles.includes(Role.ADMIN_USER))) {
          resourceList.push(<Resource name="license" home={License} icon={LicenseIcon} />);
        }

        return resourceList;
      }}
    </JApp>
  );
};

export default App;
